
import ShoppingBag from "../../../assets/duotone/ShoppingBag.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ShoppingBagIcon({ className, dataTestid = "ShoppingBagIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ShoppingBag data-testid={dataTestid} className={classes} {...rest} />
  );
}
